module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Por albarán":"Por albarán","Albarán":"Albarán","Filtro":"Filtro"},"en":{},"ca":{"Por albarán":"Per albarà","Albarán":"Albarà","Filtro":"Filtre"}}')
  delete Component.options._Ctor
}
